const identity = <T extends string>(v: T): string => v

export function Tabs<T extends string>({
  value,
  onChange,
  options,
  labelFor = identity,
}: Readonly<{
  value: T
  onChange: (v: T) => void
  options: readonly T[]
  /** The label a tab shows; the value itself by default (the product tabs,
   * whose names are literals). Settings passes a translated label (MS-997). */
  labelFor?: (v: T) => string
}>) {
  return (
    <div className="flex gap-0 border-b border-[var(--border)] mb-6">
      {options.map((opt) => (
        <button
          key={opt}
          onClick={() => onChange(opt)}
          className={`px-4 py-2.5 text-[13px] leading-[normal] font-medium -mb-px border-b-2 transition-colors ${
            value === opt
              ? 'text-[var(--accent-text)] border-[var(--accent)] font-semibold'
              : 'text-[var(--text-secondary)] border-transparent hover:text-[var(--text-primary)]'
          }`}
        >
          {labelFor(opt)}
        </button>
      ))}
    </div>
  )
}
